import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, QueryList, ChangeDetectorRef, Renderer2, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LEGAL_URLS, PRODUCT_TYPES, SOLARTS_ROOFS_TYPES } from '@apps/api-interfaces';
import { Destroyer, sleep } from '@apps/tools';
import { StorageService, zipCodeValidator, DetectDeviceService } from '@apps/ui';
import { FormSubmitDirective, ErrorMessageComponent } from '@apps/ui';
import animateScrollTo from 'animated-scroll-to';
const ɵ0 = () => `Kod pocztowy jest wymagany`, ɵ1 = () => `Błędny format kodu pocztowego`;
const errorsZip = {
    required: ɵ0,
    zipCode: ɵ1
};
const ɵ2 = () => `Wybierz rodzaj powierzchni do montażu`;
const errorsSolars = {
    required: ɵ2
};
const ɵ3 = () => `Wybierz obecnego dostawcę`;
const errorsEnergy = {
    required: ɵ3
};
const getQueryParam = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
};
const ɵ4 = getQueryParam;
export var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["NORMAL"] = 0] = "NORMAL";
    WidgetType[WidgetType["ONE_PER_PAGE"] = 1] = "ONE_PER_PAGE";
})(WidgetType || (WidgetType = {}));
export var FormSteps;
(function (FormSteps) {
    FormSteps[FormSteps["ZIPCODE"] = 0] = "ZIPCODE";
    FormSteps[FormSteps["CHOISE"] = 1] = "CHOISE";
    FormSteps[FormSteps["AMOUNT"] = 2] = "AMOUNT";
    FormSteps[FormSteps["TERM"] = 3] = "TERM";
})(FormSteps || (FormSteps = {}));
export class InitialFormComponent extends Destroyer {
    constructor(fb, storage, cdr, device, renderer, element) {
        super();
        this.fb = fb;
        this.storage = storage;
        this.cdr = cdr;
        this.device = device;
        this.renderer = renderer;
        this.element = element;
        this.errorsZip = errorsZip;
        this.errorsSolars = errorsSolars;
        this.errorsEnergy = errorsEnergy;
        this.roofs = SOLARTS_ROOFS_TYPES.filter(e => e.id !== 'other');
        this.viewTypes = FormSteps;
        this.linkFilterFn = this.defaultLinkFilterFn;
        // Linki prawne - pelne URL-e na zatrzymajlicznik.pl, otwierane w nowym oknie.
        this.legal = LEGAL_URLS;
        this._type = WidgetType.NORMAL;
        this._zipCode = this.storage.getItem('zip') || null;
        this._product = PRODUCT_TYPES[0].id;
        this.onsubmit = new EventEmitter();
    }
    set type(type) {
        this._type = Number.isFinite(+type) ? +type : WidgetType.NORMAL;
    }
    get type() {
        return this._type;
    }
    set zipCode(zip) {
        this._zipCode = zip || this.storage.getItem('zip') || null;
    }
    get zipCode() {
        return this._zipCode;
    }
    set product(e) {
        this._product = e;
        this.setFormValues();
    }
    get product() {
        return this._product;
    }
    get hiddenElements() {
        const s = getQueryParam('hide') || '';
        return s.split(',').filter(e => e !== '');
    }
    get buttonTextMessage() {
        return getQueryParam('text') || this.buttonText || 'Porównaj ceny';
    }
    ngOnInit() {
        this.setAssetExtension();
        this.rangeSelected = this.type === WidgetType.NORMAL;
        const termAccepted = !!this.storage.getItem('term');
        this.form = this.fb.group({
            zip: [this.zipCode, [Validators.required, zipCodeValidator]],
            choise: [null, [Validators.required]],
            value: [60, [Validators.required]],
            term: [
                termAccepted,
                !this.disableTerms ? [Validators.requiredTrue] : []
            ]
        }, {
            updateOn: 'submit'
        });
        this.setCurrentState();
        this.setFormValues();
    }
    onInputChanged(value) {
        this.submitted = false;
        try {
            this.resetErrors();
            this.form.markAsPristine();
        }
        catch (e) { }
    }
    resetErrors() {
        this.formRef.resetSubmit();
        this.errorRefs.toArray().forEach(err => {
            err.reset();
        });
    }
    defaultLinkFilterFn(url, event) {
        event.preventDefault();
        this.onsubmit.emit({
            url
        });
    }
    submit() {
        this.submitted = true;
        if (!this.form.valid || !this.rangeSelected) {
            this.setCurrentState();
            this.cdr.detectChanges();
            this.scrollToError();
            return;
        }
        const values = this.form.value;
        switch (this.product) {
            case 'prad':
            case 'gaz':
                values['provider'] = values['choise'];
                this.storage.setItem('provider', values['choise']);
                break;
            case 'fotowoltaika':
                values['roof'] = values['choise'];
                values['grant'] = 'true';
                values['tax'] = 'true';
                values['incvat'] = 'true';
                values['benefits'] = ['b1', 'b2', 'b3', 'b4', 'b5'];
                this.storage.setItem('roof', values['choise']);
                break;
        }
        this.storage.setItem('zip', values.zip);
        this.storage.setItem('term', 1);
        delete values['choise'];
        delete values['term'];
        this.onsubmit.emit(values);
    }
    onInputMouseEnter(event) {
        const element = event.target;
        this.choisePreview = (element && element.getAttribute('data-title')) || '';
    }
    onInputMouseLeave(event) {
        this.choisePreview = '';
    }
    reset() {
        if (this.type === WidgetType.NORMAL) {
            return;
        }
        this.storage.removeItem('zip');
        this.storage.removeItem('roof');
        this.storage.removeItem('provider');
        this.rangeSelected = undefined;
        this.form.reset({
            zip: null,
            choise: null,
            value: this.product === 'fotowoltaika' ? 3500 : 60,
            term: !!this.storage.getItem('term')
        });
        this.setCurrentState();
        this.setFormValues();
        try {
            this.resetErrors();
            this.form.markAsPristine();
        }
        catch (e) { }
    }
    setFormValues() {
        if (!this.form) {
            return;
        }
        this.onInputChanged();
        const fieldValue = this.form.get('value');
        const fieldChoise = this.form.get('choise');
        const valueFromParam = Number.isFinite(+getQueryParam('value')) && +getQueryParam('value') > 0
            ? +getQueryParam('value')
            : null;
        let choiseValue = null;
        switch (this.product) {
            case 'prad':
            case 'gaz':
                if (fieldValue.value > 500) {
                    fieldValue.setValue(valueFromParam || 60);
                }
                if (this.storage.getItem('provider')) {
                    choiseValue = this.storage.getItem('provider');
                }
                break;
            case 'fotowoltaika':
                if (fieldValue.value < 1001) {
                    fieldValue.setValue(valueFromParam || 3500);
                }
                if (this.storage.getItem('roof')) {
                    choiseValue = this.storage.getItem('roof');
                }
                break;
        }
        fieldChoise.reset(choiseValue);
        this.setCurrentState();
    }
    setAssetExtension() {
        if (this.device.isiOS || this.device.isSafari) {
            this.renderer.addClass(this.element.nativeElement, 'jp2');
        }
        else {
            this.renderer.addClass(this.element.nativeElement, 'webp');
        }
    }
    scrollToError() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield sleep(300);
            const element = document.querySelector('sc-initial-form sc-error > p');
            if (!element) {
                return;
            }
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            animateScrollTo(elementPosition, {
                verticalOffset: -400,
                speed: 1400
            });
        });
    }
    setCurrentState() {
        if (!this.form)
            return;
        if (this.type !== WidgetType.ONE_PER_PAGE ||
            (this.type === WidgetType.ONE_PER_PAGE &&
                this.hiddenElements.length !== 0)) {
            return;
        }
        const data = this.form.value;
        if (!data.zip) {
            this.currentView = FormSteps.ZIPCODE;
            return;
        }
        if (!data.choise) {
            this.currentView = FormSteps.CHOISE;
            return;
        }
        if (!data.value || !this.rangeSelected) {
            this.currentView = FormSteps.AMOUNT;
            this.rangeSelected = true;
            return;
        }
        if (!data.term) {
            this.currentView = FormSteps.TERM;
            return;
        }
    }
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
